(() => {
  function initializeDolobitesSummaryV3() {
    const booking = document.querySelector('.db-booking');

    if (!booking || booking.dataset.summaryV3Initialized === 'true') {
      return;
    }

    const config = window.DOLOBITES_BOOKING_CONFIG;

    if (!config) {
      console.error('Dolobites booking config is missing.');
      return;
    }

    booking.dataset.summaryV3Initialized = 'true';

    const formatCurrency = (amount) =>
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: config.currency || 'USD',
        minimumFractionDigits:
          Number(amount) % 1 === 0 ? 0 : 2,
        maximumFractionDigits:
          Number(amount) % 1 === 0 ? 0 : 2
      }).format(Number(amount) || 0);

    const formatDate = (value) => {
      if (!value) return 'Not selected';

      const date = new Date(`${value}T12:00:00`);

      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return new Intl.DateTimeFormat('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
      }).format(date);
    };

    const setText = (selector, value, fallback = 'Not selected') => {
      const element = booking.querySelector(selector);

      if (!element) return;

      element.textContent =
        value || value === 0 ? value : fallback;
    };

    const getSelectedFlavours = () => {
      return Array.from(
        booking.querySelectorAll(
          '.db-booking__flavour-card.is-selected'
        )
      )
        .map((card) => {
          const flavourId = card.dataset.flavourId;

          return config.flavours.find(
            (flavour) => flavour.id === flavourId
          );
        })
        .filter(Boolean);
    };

    const getSelectedExtras = () => {
      return Array.from(
        booking.querySelectorAll(
          '.db-booking__extra-card.is-selected'
        )
      )
        .map((card) => {
          const extraId = card.dataset.extraId;

          if (extraId) {
            return config.extras.find(
              (extra) => extra.id === extraId
            );
          }

          const nameElement = card.querySelector(
            '.db-booking__extra-name'
          );

          const extraName =
            nameElement?.textContent?.trim() || '';

          return config.extras.find(
            (extra) => extra.name === extraName
          );
        })
        .filter(Boolean);
    };

    const calculateExtraPrice = (extra, guests) => {
      if (extra.pricingType === 'perGuest') {
        return Number(extra.price || 0) * guests;
      }

      return Number(extra.price || 0);
    };

    const updateSummaryV3 = () => {
      const selection =
        window.DOLOBITES_V3_SELECTION || {};

      const dateInput = booking.querySelector('#db-event-date');
      const locationInput = booking.querySelector(
        '#db-event-location'
      );

      const selectedEvent = booking.querySelector(
        '.db-booking__event-card.is-selected'
      );

      const selectedFlavours = getSelectedFlavours();
      const selectedExtras = getSelectedExtras();

      const guests =
  Number(selection.guests) || 0;

      const pans = Number(selection.pans) || 0;
      const experienceName =
        selection.name || ``;

      const basePrice =
        Number(selection.price) || 0;

      const premiumFlavoursTotal =
        selectedFlavours.reduce(
          (total, flavour) =>
            total + Number(flavour.extraPrice || 0),
          0
        );

      const extrasTotal =
        selectedExtras.reduce(
          (total, extra) =>
            total + calculateExtraPrice(extra, guests),
          0
        );
        const travelFee =
  Number(
    window.DOLOBITES_V3_LOCATION?.travelFee
  ) || 0;

      const total =
  basePrice +
  premiumFlavoursTotal +
  extrasTotal +
  travelFee;

      const depositPercentage =
        Number(config.depositPercentage) || 50;

      const deposit =
        total * (depositPercentage / 100);

      setText(
        '#db-summary-date',
        formatDate(dateInput?.value)
      );

      setText(
        '#db-summary-event',
        selectedEvent?.dataset.eventType
      );

      setText(
        '#db-summary-location',
        locationInput?.value?.trim()
      );

      setText(
  '#db-summary-guests',
  guests > 0 ? String(guests) : '',
  'Not selected'
      );

      setText(
        '#db-summary-package',
        experienceName
      );

      setText(
        '#db-summary-flavours',
        selectedFlavours.length
          ? selectedFlavours
              .map((flavour) => flavour.name)
              .join(', ')
          : 'Not selected'
      );

      setText(
        '#db-summary-extras',
        selectedExtras.length
          ? selectedExtras
              .map((extra) => extra.name)
              .join(', ')
          : 'None',
        'None'
      );
      const travelRow = booking.querySelector(
  '#db-summary-travel-row'
);

if (travelRow) {
  travelRow.hidden = false;
}

const hasExperience =
  Boolean(selection.name) &&
  Number(selection.price) > 0;

setText(
  '#db-summary-travel',
  hasExperience
    ? formatCurrency(travelFee)
    : '—',
  '—'
);

setText(
  '#db-summary-total',
  hasExperience
    ? formatCurrency(total)
    : '—',
  '—'
);

setText(
  '#db-summary-deposit',
  hasExperience
    ? formatCurrency(deposit)
    : '—',
  '—'
);
    };

    const scheduleUpdate = () => {
      window.setTimeout(updateSummaryV3, 0);
    };

    document.addEventListener(
      'dolobites:pans-change',
      scheduleUpdate
    );
    document.addEventListener(
  'dolobites:location-change',
  scheduleUpdate
);

    booking.addEventListener('input', scheduleUpdate);
    booking.addEventListener('change', scheduleUpdate);
    booking.addEventListener('click', scheduleUpdate);

    updateSummaryV3();
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeDolobitesSummaryV3
    );
  } else {
    initializeDolobitesSummaryV3();
  }

  document.addEventListener(
    'shopify:section:load',
    initializeDolobitesSummaryV3
  );
})();